<template>
  <div class="my-4">
    <section-title content="Documentos" icon="fas fa-file-plus" reverse />
    <custom-result-not-found v-if="documents.length === 0" />
    <div v-for="(item, idx) in documents" :key="`type-${idx}`">
      <div class="bg-secondary-3 mt-3 rounded py-3 px-4">
        <div class="row">
          <div class="col-md-6">
            <label class="data-title mb-0">Documento:</label>
            <h6>{{ item.documentTypeName | empty }}</h6>
          </div>
          <div class="col-md-4">
            <label class="data-title mb-0">Archivo:</label>
            <h6>{{ item.documentName | empty }}</h6>
          </div>
          <div class="col-md-2 d-flex align-items-center justify-content-end">
            <div class="mt-3">
              <action-button
                v-if="canDownloadDocument"
                :id="'download-document' + idx"
                class="mr-2 bg-green border-green"
                i="fas fa-file-download text-white mr-n1 pr-1"
                @click="downloadDocument(item)"
              />
              <action-button
                :id="'view-document' + idx"
                class="border-green bg-transparent"
                i="fas fa-search-plus text-green mr-n1 pr-1"
                @click="viewDocument(item)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//Component Libs
import CustomResultNotFound from 'custom-result-not-found';
import ActionButton from 'ActionButton';
import SectionTitle from 'SectionTitle';

export default {
  name: 'ProposalRequestDocuments',
  components: {
    CustomResultNotFound,
    ActionButton,
    SectionTitle,
  },
  props: {
    documents: {
      type: Array,
      required: true,
    },
  },
  computed: {
    canDownloadDocument() {
      return this.userHasPermissions('provider.proposal.documents.download');
    },
  },
  methods: {
    downloadDocument(item) {
      this.$emit('donwload', item);
    },
    viewDocument(item) {
      this.$emit('view', item);
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.border-green {
  border-color: map-get($colors, 'green');
}
</style>
